import { webClient } from "@shared/apis"
import CabinetResponse from "../types/CabinetResponse";

const CabinetApi = {
  post: async (formData: FormData) =>
    webClient.post<CabinetResponse>(
      `${process.env.REACT_APP_CABINET_API}/uploads`,
      formData,
      {
        headers: {
          "Content-Type": `multipart/form-data`
        },
        transformRequest: [(data) => data]
      }
    )
};

export default CabinetApi;
